import TagsAlt from './tagsAlt.js';
export default TagsAlt;
